import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnChanges} from '@angular/core';
import {fadeInAnimation} from "../../environments/animation";

// import {} from "@angular/compiler/src/core";

/**
 * Generated class for the SearchHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 * an is abbr of avatar-nickname
 */
@Component({
  selector: 'search-header',
  templateUrl: 'search-header.html',
  animations: [fadeInAnimation],
})
export class SearchHeaderComponent implements AfterViewInit,OnChanges{
  @ViewChild('container') container: ElementRef;
  topOffset;

  @Input() anList;
  @Input() haveSearch: boolean = true;
  @Output() onAnChange = new EventEmitter();
  @Output() onKeywordChange = new EventEmitter();
  @Output() onLoadMore = new EventEmitter();
  @Input() value:string = 'nickname';
  @Input() avatar:string = 'avatar_url';
  @Input() id:string = 'id';



  constructor() {
    console.log('Hello SearchHeaderComponent Component');
  }

  ngAfterViewInit(): void {
    setTimeout(()=>{
      this.topOffset = this.container.nativeElement.offsetTop + this.container.nativeElement.clientHeight;
    });
  }
  ngOnChanges(){
    console.log(this.value);
    console.log(this.avatar);
    console.log(this.id);
  }

  isShowChange: boolean;
  selectedAn;

  selectAn(an?) {
    if (this.selectedAn != an) {
      this.selectedAn = an;
      this.onAnChange.emit(this.selectedAn);
    }
  }

  isSearch;

  showSearch() {
    this.isSearch = true;
  }

  /**
   * 也暴露给父组件调用*/
  public hideSearch() {
    this.isSearch = false;
    this.isFouceSearch = false;
    this.searchString = '';
    this.keyword = undefined;
  }

  searchString;

  onSearch(e) {
    if (e.keyCode == 13 && this.searchString) {
      this.startSearch(this.searchString);
    }
  }

  keyword;
  isFouceSearch;

  startSearch(search) {
    this.isFouceSearch = false;
    if (search && search.trim()) {
      this.keyword = search.trim();
    }
    else {
      this.keyword = null;
      this.isSearch = false;
      this.showSearch();
    }
    this.onKeywordChange.emit(this.keyword);
  }

  dataPre;
  loadMore(e){
    let el = e.target;
    if (
      el.scrollTop + el.clientHeight > el.scrollHeight - 1
    ) {
      //这里是为了在加载下一页之中不被触发
      if (this.anList != this.dataPre) {
        this.dataPre = this.anList;
        this.onLoadMore.emit();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/search-header/search-header.ts